// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@tailwind base;*/

/**
 * Custom base styles
 */

html {
    font-size: 62.5%;
    font-family: 'Inter var', Roboto, Helvetica Neue, Arial, sans-serif;
    background-color: #121212;
    -webkit-font-smoothing: antialiased;
    text-size-adjust: 100%;
}

body {
    font-size: 13px;
    line-height: 1.4;
    overflow-x: hidden;
}

html, body, #root {
    position: relative;
    margin: 0;
    min-height: 100vh;
}

h1, .h1 {
    font-size: 24px;
}

h2, .h2 {
    font-size: 20px;
}

h3, .h3 {
    font-size: 16px;
}

h4, .h4 {
    font-size: 15px;
}

h5, .h5 {
    font-size: 13px;
}

h6, .h6 {
    font-size: 12px;
}

.ps > .ps__rail-y,
.ps > .ps__rail-x {
    z-index: 99;
}

a[role=button] {
    text-decoration: none;
}

[role="tooltip"] {
    z-index: 9999;
}

/* Medium Devices, Desktops Only */
@media only screen and (min-width: 992px) {
    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: rgba(0, 0, 0, 0);
    }

    ::-webkit-scrollbar:hover {
        width: 8px;
        height: 8px;
        background-color: rgba(0, 0, 0, 0.06);
    }

    ::-webkit-scrollbar-thumb {
        border: 2px solid transparent;
        border-radius: 20px;
    }

    ::-webkit-scrollbar-thumb:active {
        border-radius: 20px;
    }
}

form label {
    z-index: 99;
}

body.no-animate *,
body.no-animate *::before,
body.no-animate *::after {
    transition: none !important;
    animation: none !important;
}

button:focus {
    outline: none;
}

/* Removes webkit's autofill backgorund color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active
{
    transitionDelay: 9999s;
    transitionProperty: background-color, color;
}

:focus {
    outline-color: transparent;
}

/*fullcalendar Fix*/
.fc-scrollgrid-section-liquid {
    height: 1px !important;
}

.muiltr-1u2taa6{
    margin-top: -5px;
}

.swal-footer { text-align: center; }`, "",{"version":3,"sources":["webpack://./src/styles/app-base.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;;EAEE;;AAEF;IACI,gBAAgB;IAChB,mEAAmE;IACnE,yBAAyB;IACzB,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA,kCAAkC;AAClC;IACI;QACI,UAAU;QACV,WAAW;QACX,kCAAkC;IACtC;;IAEA;QACI,UAAU;QACV,WAAW;QACX,qCAAqC;IACzC;;IAEA;QACI,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;;;IAGI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA,+CAA+C;AAC/C;;;;;IAKI,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,eAAe,kBAAkB,EAAE","sourcesContent":["/*@tailwind base;*/\n\n/**\n * Custom base styles\n */\n\nhtml {\n    font-size: 62.5%;\n    font-family: 'Inter var', Roboto, Helvetica Neue, Arial, sans-serif;\n    background-color: #121212;\n    -webkit-font-smoothing: antialiased;\n    text-size-adjust: 100%;\n}\n\nbody {\n    font-size: 13px;\n    line-height: 1.4;\n    overflow-x: hidden;\n}\n\nhtml, body, #root {\n    position: relative;\n    margin: 0;\n    min-height: 100vh;\n}\n\nh1, .h1 {\n    font-size: 24px;\n}\n\nh2, .h2 {\n    font-size: 20px;\n}\n\nh3, .h3 {\n    font-size: 16px;\n}\n\nh4, .h4 {\n    font-size: 15px;\n}\n\nh5, .h5 {\n    font-size: 13px;\n}\n\nh6, .h6 {\n    font-size: 12px;\n}\n\n.ps > .ps__rail-y,\n.ps > .ps__rail-x {\n    z-index: 99;\n}\n\na[role=button] {\n    text-decoration: none;\n}\n\n[role=\"tooltip\"] {\n    z-index: 9999;\n}\n\n/* Medium Devices, Desktops Only */\n@media only screen and (min-width: 992px) {\n    ::-webkit-scrollbar {\n        width: 8px;\n        height: 8px;\n        background-color: rgba(0, 0, 0, 0);\n    }\n\n    ::-webkit-scrollbar:hover {\n        width: 8px;\n        height: 8px;\n        background-color: rgba(0, 0, 0, 0.06);\n    }\n\n    ::-webkit-scrollbar-thumb {\n        border: 2px solid transparent;\n        border-radius: 20px;\n    }\n\n    ::-webkit-scrollbar-thumb:active {\n        border-radius: 20px;\n    }\n}\n\nform label {\n    z-index: 99;\n}\n\nbody.no-animate *,\nbody.no-animate *::before,\nbody.no-animate *::after {\n    transition: none !important;\n    animation: none !important;\n}\n\nbutton:focus {\n    outline: none;\n}\n\n/* Removes webkit's autofill backgorund color */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active\n{\n    transitionDelay: 9999s;\n    transitionProperty: background-color, color;\n}\n\n:focus {\n    outline-color: transparent;\n}\n\n/*fullcalendar Fix*/\n.fc-scrollgrid-section-liquid {\n    height: 1px !important;\n}\n\n.muiltr-1u2taa6{\n    margin-top: -5px;\n}\n\n.swal-footer { text-align: center; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
